import { cn } from "../../lib/utils";

export const BentoGrid = ({
  className,
  children
}) => {
  return (
    <div
      className={cn(
        "mx-auto grid max-w-7xl gap-4 auto-rows-[18rem] [grid-template-columns:repeat(auto-fit,minmax(350px,1fr))] md:grid-cols-3",
        className
      )}>
      {children}
    </div>
  );
};

export const BentoGridItem = ({
  id,
  className,
  title,
  description,
  header,
  icon
}) => {
  const isHeaderOnly = !title && !description; // 🔥 automatic detection

  return (
    <div
      key={id}
      className={cn(
        "group/bento shadow-input row-span-1 flex flex-col justify-between space-y-4 rounded-xl transition duration-200 hover:shadow-xl dark:border-white/[0.2] dark:bg-black dark:shadow-none",
        className
      )}
      style={{
        background: "rgb(4, 17, 29)",
        backgroundImage:
          "linear-gradient(90deg, rgba(4,7,29,1) 0%, rgba(12,14,35,1) 100%)",
        border: "1px solid #404040"
      }}
    >
      {isHeaderOnly ? (
        // 🔥 Full header mode (fills entire card)
        <div className="flex flex-1 w-full h-full flex justify-center">
          {header}
        </div>
      ) : (
        <>
          {title && (
            <div className="font-sans font-bold text-2xl text-white dark:text-white-200">
              {title}
            </div>
          )}
          {header}
          {/* {description && (
            <div className="transition duration-200 -mt-2 text-sm text-neutral-400">
              {description}
            </div>
          )} */}
        </>
      )}
    </div>
  );
};
